export default "<p>not-found works!</p>\n\n\n<app-footer></app-footer>"